<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="dialog"
      ref="layout"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.native="dismiss();">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{translater.__('Edit Checkpoint', 'checkpoints')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items></v-toolbar-items>
        </v-toolbar>
        <v-container grid-list-md text-xs-center>
          <v-layout row wrap>
            <v-flex xs12>
              <!--v-card v-if="!add && !edit">
		      	<v-card-title primary-title>
		      		<h3></h3>
		      	</v-card-title>
		      	<v-card-text>
		      		<v-form>
		      			<v-text-field
		      			:label="translater.__('Name')"
		      			v-model="editableFeatureName"
		      			></v-text-field>
		      		</v-form>
		      	</v-card-text>
		      	
              </v-card-->

              <v-card v-if="checkPoint.properties.subTasks.length == 0 && !add && !edit">
                <v-img src="images/logo.png" aspect-ratio="2.75"></v-img>

                <v-card-title primary-title>
                  <div>
                    <h3 class="headline">{{translater.__('No tasks', 'checkpoints')}}</h3>
                  </div>
                </v-card-title>

                <v-card-actions>
                  <v-btn
                    @click="addTask()"
                    flat
                    color="primary"
                  >{{translater.__("Add Task", 'checkpoints')}}</v-btn>
                </v-card-actions>
              </v-card>
              <div v-if="checkPoint.properties.subTasks.length > 0 && !add && !edit">
                <v-card>
                  <v-card-actions>
                    <v-btn
                      @click="addTask()"
                      flat
                      color="primary"
                    >{{translater.__("Add Task", 'checkpoints')}}</v-btn>
                    <v-btn
                      v-if="!reordered"
                      @click="toggleDragging()"
                      :disabled="checkPoint.properties.subTasks.length <= 1"
                      justify-right
                      small
                      flat
                      color="primary"
                    >{{!draggable ? translater.__('Enable Dragging', 'checkpoints') : translater.__('Disable Dragging', 'checkpoints')}}</v-btn>
                    <v-btn
                      v-else
                      @click="saveReordered()"
                      small
                      flat
                      color="success"
                    >{{translater.__('Save')}}</v-btn>
                  </v-card-actions>
                </v-card>
                <v-container>
                  <v-card
                    @drop.native="drop($event, stIndex)"
                    @dragover.native="allowDrop($event, stIndex)"
                    @dragstart.native="drag($event, stIndex)"
                    :draggable="draggable"
                    v-for="(st,stIndex) in subTasks"
                    :key="stIndex"
                  >
                    <v-card-title primary-title>
                      <h3 class="headline">{{getTaskType(st.type)}}</h3>
                    </v-card-title>
                    <v-card-text justify-center>
                      <v-img
                        :src="getImageSrcByTaskType(st.type)"
                        :max-width="128"
                        :max-height="128"
                      ></v-img>
                      <v-container class="reorder-buttons">
                        <v-btn
                          icon
                          @click="moveUp(stIndex)"
                          :disabled="checkPoint.properties.subTasks.length <= 1 || stIndex === 0"
                        >
                          <v-icon>arrow_upward</v-icon>
                        </v-btn>
                        <v-btn
                          @click="moveDown(stIndex)"
                          icon
                          :disabled="checkPoint.properties.subTasks.length <= 1 || stIndex === checkPoint.properties.subTasks.length - 1"
                        >
                          <v-icon>arrow_downward</v-icon>
                        </v-btn>
                      </v-container>
                    </v-card-text>
                    <!--v-img v-if="st.type===20"
						src="/images/icon_image.png"
					   aspect-ratio="1"
                    ></v-img-->

                    <v-card-title sub-title>
                      <div v-if="st.delete === false">
                        <h3 class="headline">{{translater.__(st.question.content, 'tasks')}}</h3>
                        <div>{{translater.__(st.question.description, 'tasks')}}</div>
                      </div>
                      <div
                        v-else
                      >{{translater.__('Are you sure you want to delete this task?', 'tasks')}}</div>
                    </v-card-title>
                    <v-card-actions v-if="st.delete === false">
                      <v-btn @click="editTask(st)" flat color="primary" small>
                        <v-icon>edit</v-icon>
                        {{translater.__('Edit')}}
                      </v-btn>
                      <v-btn
                        :disabled="isRemovingTask"
                        @click="() => {
			        		if(!SOFT_DELETE)
			        		{
			        			removeTask(st);
			        		} else if(SOFT_DELETE && !st.removed){
			        			confirmRemoveTask(st);
			        		} else if(SOFT_DELETE && st.removed)
			        		{
			        			confirmRemoveTask(st, true)
			        		}
			        	}"
                        flat
                        color="error"
                        small
                      >
                        <v-icon>{{getDeleteButtonIcon(st)}}</v-icon>
                        {{translater.__(getDeleteButtonText(st))}}
                      </v-btn>
                      <v-btn
                        @click="restoreTask(st)"
                        small
                        flat
                        color="primary"
                        v-if="SOFT_DELETE && st.removed"
                      >
                        <v-icon>restore_from_trash</v-icon>
                        {{translater.__('Restore')}}
                      </v-btn>
                    </v-card-actions>
                    <v-card-actions v-if="st.delete === true">
                      <!--v-btn @click="confirmRemoveTask(st)" color="primary" small>
			        		<v-icon>check</v-icon>
			        		{{translater.__('OK')}}
                      </v-btn-->
                      <SuccessButton
                        button-text="OK"
                        :valid="true"
                        :onClick="() => confirmRemoveTask(st, true)"
                      />
                      <ErrorButton :onClick="() => cancelRemoveTask(st)"></ErrorButton>
                    </v-card-actions>
                  </v-card>
                </v-container>
                <v-card>
                  <v-card-actions>
                    <v-btn
                      @click="addTask()"
                      flat
                      color="primary"
                    >{{translater.__("Add Task", 'checkpoints')}}</v-btn>
                    <v-btn
                      v-if="!reordered"
                      @click="toggleDragging()"
                      :disabled="checkPoint.properties.subTasks.length <= 1"
                      justify-right
                      small
                      flat
                      color="primary"
                    >{{!draggable ? translater.__('Enable Dragging', 'checkpoints') : translater.__('Disable Dragging', 'checkpoints')}}</v-btn>
                    <v-btn
                      v-else
                      @click="saveReordered()"
                      small
                      flat
                      color="success"
                    >{{translater.__('Save')}}</v-btn>
                  </v-card-actions>
                </v-card>
              </div>

              <!-- add alkaa -->

              <AddTask v-if="add" />
              <EditTask v-if="edit && !add"></EditTask>

              <!-- add loppuu -->
            </v-flex>
          </v-layout>
          <!--div v-if="!add && !edit">
		  <v-btn @click="acceptFeatureEdit()" small color="success">
  			<v-icon>save</v-icon>
  			{{translater.__('Save')}}
  		</v-btn>
  		<v-btn @click="dismiss()" small color="primary">
  			<v-icon>cancel</v-icon>
  			{{translater.__('Cancel')}}
  		</v-btn>
          </div-->
        </v-container>
      </v-card>
    </v-dialog>
  </v-layout>
</template>


<script>
import { SOFT_DELETE } from "../../../constants/";
import Upload from "./Upload";
import AddTask from "./AddTask";
import EditTask from "./EditTask";
//import draggable from 'vuedraggable'
import SuccessButton from "../../../common/components/SuccessButton";
import ErrorButton from "../../../common/components/ErrorButton";
export default {
  name: "EditCheckpoint",
  components: { ErrorButton, SuccessButton, Upload, AddTask, EditTask },

  data() {
    return {
      form: undefined,
      fromIndex: null,
      targetIndex: null,
      subTasks: [],
      //originalOrder: [],
      draggable: false,
      reordered: false,
      isRemovingTask: false,
      SOFT_DELETE: SOFT_DELETE
    };
  },

  created() {},

  mounted() {
    this.$nextTick(() => {
      document.getElementsByClassName(
        "v-dialog__content"
      )[0].style.zIndex = 3000;
    });
  },

  methods: {
    getDeleteButtonText(st) {
      let text = "Hide";
      if (SOFT_DELETE && st.removed === true) {
        text = "Delete";
      } else if (!SOFT_DELETE) {
        text = "Delete";
      }

      return text;
    },

    getDeleteButtonIcon(st) {
      let text = "visibility_off";
      if (SOFT_DELETE && st.removed === true) {
        text = "delete";
      } else if (!SOFT_DELETE) {
        text = "delete";
      }

      return text;
    },

    restoreTask(st) {
      this.$store.dispatch("checkpoints/restoreTask", st);
    },

    moveUp(stIndex) {
      this.fromIndex = stIndex;
      this.targetIndex = this.fromIndex - 1;
      this.reorder();
    },

    moveDown(stIndex) {
      this.fromIndex = stIndex;
      this.targetIndex = this.fromIndex + 1;
      this.reorder();
    },

    saveReordered() {
      this.$store.dispatch("checkpoints/reorder", this.subTasks);
      this.reordered = false;
      this.draggable = false;
    },

    toggleDragging() {
      this.draggable = !this.draggable;
    },

    reorder() {
      //this.subTasks.splice(this.targetIndex, 0, this.subTasks.splice(this.fromIndex, 1)[0]);
      //this.subTasks = this.subTasks.slice();

      let subtasks = this.subTasks;
      subtasks.splice(
        this.targetIndex,
        0,
        subTasks.splice(this.fromIndex, 1)[0]
      );
      this.subTasks = subtasks.slice();

      this.reordered = true;

      //subTasks = null;
    },

    drop(e, stIndex) {
      e.preventDefault();

      this.targetIndex = stIndex;
      if (this.fromIndex !== this.targetIndex) {
        this.reorder();
      }
    },

    allowDrop(e) {
      e.preventDefault();
    },

    drag(e, stIndex) {
      if (!this.draggable) {
        e.preventDefault();
        return;
      }

      this.fromIndex = stIndex;
    },

    getImageSrcByTaskType(searchedType) {
      let types = this.$store.getters["checkpoints/taskTypes"];

      let found = types.find(t => {
        return t.value === searchedType;
      });
      let src = "";
      if (found && typeof found.src !== "undefined") {
        src = found.src;
      }

      return src;
    },

    getTaskType(searchedType) {
      let types = this.$store.getters["checkpoints/taskTypes"];

      let found = types.find(t => {
        return t.value === searchedType;
      });
      let type = "";
      if (found) {
        type = found.text;
      }

      return this.translater.__(type, "tasks");
    },

    dismiss() {
      this.dialog = false;
      this.cancelFeatureEdit();
    },

    addTask() {
      this.add = true;
      this.taskType = 0;
      this.$store.dispatch("checkpoints/flushNewTask");
      this.$store.commit("files/flushFilesToUpload");
    },

    editTask(task) {
      this.$store.dispatch("checkpoints/editTask", task);
    },

    removeTask(task) {
      this.isRemovingTask = true;
      this.$store.dispatch("checkpoints/removeTask", {
        task: task,
        type: true
      });
    },

    cancelRemoveTask(task) {
      this.$store.dispatch("checkpoints/removeTask", {
        task: task,
        type: false
      });
      this.isRemovingTask = false;
    },

    confirmRemoveTask(st, hardDelete = false) {
      this.$store.dispatch("checkpoints/destroyTask", { st, hardDelete });
      this.isRemovingTask = false;
    },

    acceptFeatureEdit() {
      this.dialog = false;
      this.$store.dispatch("routes/acceptFeatureEdit");
    },

    cancelFeatureEdit() {
      this.$store.dispatch("routes/cancelFeatureEdit");
    }
  },

  computed: {
    dialog: {
      get() {
        return this.$store.getters["checkpoints/showEditCheckpointDialog"];
      },

      set(value) {
        this.$store.dispatch("checkpoints/setShowEditCheckpointDialog", value);
      }
    },

    translater: {
      get() {
        return this.$store.getters["translate/translater"];
      }
    },

    checkPoint: {
      get() {
        let checkPoint = this.$store.getters["checkpoints/checkPoint"];
        this.subTasks = checkPoint.properties.subTasks;
        //this.originalOrder = this.subTasks.slice();

        return checkPoint;
      }
    },

    isFetching: {
      get() {
        return this.$store.getters["checkpoints/isFetching"];
      },

      set(value) {
        this.$store.dispatch("checkpoints/setIsFetching", value);
      }
    },

    add: {
      get() {
        return this.$store.getters["checkpoints/add"];
      },

      set(value) {
        this.$store.dispatch("checkpoints/setAddCheckpoint", value);
      }
    },

    edit: {
      get() {
        return this.$store.getters["checkpoints/editTask"];
      }
    },

    showUploadForm: {
      get() {
        return this.$store.getters["checkpoints/showUploadForm"];
      }
    },

    taskTypes: {
      get() {
        return this.$store.getters["checkpoints/taskTypes"];
      }
    },

    taskType: {
      get() {
        return this.$store.getters["checkpoints/newTaskTyep"];
      },

      set(value) {
        this.$store.dispatch("checkpoints/setNewTaskType", value);
      }
    },

    editableFeatureName: {
      get() {
        return this.$store.getters["routes/editableFeature"].properties.name;
      },

      set(value) {
        this.$store.dispatch("routes/setEditableFeatureName", value);
      }
    }
  }
};
</script>

<style scoped>
.v-card {
  margin-bottom: 2em;
}

.reorder-buttons {
  text-align: right;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  margin-top: 150px;
}

.btn {
  border: 2px solid gray;
  color: gray;
  background-color: white;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 20px;
  font-weight: bold;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

.box {
  background-color: white;
  outline: 2px dashed black;
  outline-offset: -10px;
  min-height: 300px;
}

.box__dragndrop {
  display: inline;
}
</style>